
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(8(47|58|88)|(47|57|60|66)9|(|5)13|021|225|270|457|975)|2((24|86|94)7|(2|61|98)9|11|133|840)|5(1(44|75|77|93)|5(39|83|97)|3(09|78|79)|6(37|4|81|91)|244|891|963)|6(017|121|419|499|66|732|935|970)|1(23|24|322|358|569|657|733|789)|8((|8)51|(|0|4)87|025|169|430|503|63|992)|7(4(24|39|51|61)|5(31|47|5)|(28|68|75|99)1|(00|20|79)3|127|195|368|38|632|97)|3(9(2|43|57)|(0|15|28|3|69)7|(|5)35|443|721|781)|9(1(|06|25)|4(21|29|57)|9(|1|5)|032|293|355|614|653))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
